import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import Layout from './components/Layout';

// Lazy load pages
const Dashboard = lazy(() => import('./pages/Dashboard'));
const Tools = lazy(() => import('./pages/Tools'));
const Profile = lazy(() => import('./pages/Profile'));
const Money = lazy(() => import('./pages/Money'));
const Earn = lazy(() => import('./pages/Earn'));
const Shopping = lazy(() => import('./pages/Shopping'));
const Admin = lazy(() => import('./pages/Admin'));
const Community = lazy(() => import('./pages/Community'));
const LegalInfo = lazy(() => import('./pages/LegalInfo'));
const WhopEarnings = lazy(() => import('./pages/WhopEarnings'));

// Loading fallback
const LoadingFallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
    <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
  </div>
);

function App() {
  return (
    <AppProvider>
      <Layout>
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/money" element={<Money />} />
            <Route path="/earn" element={<Earn />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/shooting" element={<Shopping />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/community" element={<Community />} />
            <Route path="/legal" element={<LegalInfo />} />
            <Route path="/whop" element={<WhopEarnings />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </Layout>
    </AppProvider>
  );
}

export default App;